import {Typography} from '@mui/material';
import Box from '@mui/material/Box';
import {styled} from '@mui/material/styles';

export const ProductStatusContainer = styled(Box)(({theme}) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  position: 'absolute',
  flexDirection: 'column',
  alignItems: 'center',
  height: theme.spacing(25),
  minHeight: theme.spacing(25),
  [theme.breakpoints.down('sm')]: {
    height: theme.spacing(20),
    minHeight: theme.spacing(20)
  },
  '&.pdp': {
    height: '100%',
    width: '100%'
  },
  '&.pdpRevamp': {
    [theme.breakpoints.up('tablet')]: {
      marginTop: theme.spacing(22)
    },
    [theme.breakpoints.only('tablet')]: {
      marginTop: theme.spacing(9.75)
    },
    [theme.breakpoints.down('tablet')]: {
      marginTop: theme.spacing(12.25)
    }
  },
  '&.compact': {
    height: theme.spacing(18),
    minHeight: theme.spacing(18)
  },
  '&.ads': {
    height: theme.spacing(15),
    minHeight: theme.spacing(15),
    width: '100%'
  }
}));

export const ProductStatusComponent = styled(Box)(({theme}) => ({
  position: 'absolute',
  zIndex: 1,
  borderRadius: theme.spacing(3),
  background: '#000000B2',
  height: 'auto'
}));

export const ProductStatusLabel = styled(Typography)(({theme}) => ({
  fontSize: theme.spacing(2),
  fontWeight: 600,
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  alignItems: 'center',
  color: theme.palette.common.white,
  textAlign: 'center'
}));
